import { helper } from '@ember/component/helper';
export function inArray([array, item]) {
  return array.includes(item);
}
export default helper(inArray);